import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    const newElement = this.containerTarget.lastElementChild
    const firstInput = newElement.querySelector("input")
    if (firstInput) firstInput.focus()
  }
}
